import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IcDelete16Icon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';

import { CommonPayload } from '../CommonPayload/CommonPayload';
import styles from './DeletedByMePayload.styles.m.css';

interface IDeleteByMePayloadProps {
  name: string;
}

export const DeletedByMePayload: FC<IDeleteByMePayloadProps> = observer(({ name }) => {
  const { t } = useTranslation();

  return (
    <CommonPayload
      name={name}
      description={t('common_message_deleted')}
      iconClassName={styles.icon}
      Icon={IcDelete16Icon}
    />
  );
});
